"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const core_shared_1 = require("@ikegps/core-shared");
class MeasurementState {
    constructor() {
        this.points = [];
        this.isActive = false;
        this.isPaused = false;
    }
    setActive(active) {
        this.isActive = active;
        if (!active) {
            this.isPaused = false;
        }
    }
    setPaused(paused) {
        this.isPaused = paused;
    }
    addPoint(point) {
        this.points.push(point);
    }
    updatePointLocation(id, location) {
        const point = this.points.find((p) => p.id === id);
        if (point) {
            point.location = location;
        }
    }
    removePoint(pointId) {
        const index = this.points.findIndex((p) => p.id === pointId);
        if (index !== -1) {
            this.points.splice(index, 1);
        }
    }
    clearPoints() {
        this.points = [];
    }
    reset() {
        this.points = [];
        this.isActive = false;
        this.isPaused = false;
    }
    /**
     * Check if a point already exists at this location (for undo functionality)
     */
    findPointByLocation(location, toleranceMeters = 1) {
        return (this.points.find((point) => {
            const distance = google.maps.geometry.spherical.computeDistanceBetween(point.location, location);
            return distance < toleranceMeters;
        }) || null);
    }
    /**
     * Find a point by collection revision (for pole clicks)
     */
    findPointByCollection(collectionRevision) {
        return this.points.find((p) => p.collectionRevision === collectionRevision) || null;
    }
    /**
     * Get distance between consecutive points (spans)
     * Returns array of distances in meters
     */
    get spanDistances() {
        const distances = [];
        for (let i = 1; i < this.points.length; i++) {
            const prevPoint = this.points[i - 1];
            const currentPoint = this.points[i];
            const prevLoc = {
                latitude: prevPoint.location.lat(),
                longitude: prevPoint.location.lng(),
                altitude: 0,
            };
            const currentLoc = {
                latitude: currentPoint.location.lat(),
                longitude: currentPoint.location.lng(),
                altitude: 0,
            };
            const vector = core_shared_1.IkeGeodesic.getVector(prevLoc, currentLoc);
            distances.push(vector.distance);
        }
        return distances;
    }
    /**
     * Calculate ruling span using the formula: sqrt(sum(distance^3) / totalDistance)
     * Returns ruling span in meters, or 0 if less than 2 points
     */
    get rulingSpan() {
        if (this.points.length < 2) {
            return 0;
        }
        const totalDistance = this.totalDistance;
        if (totalDistance === 0) {
            return 0;
        }
        let numerator = 0;
        for (const distance of this.spanDistances) {
            numerator += Math.pow(distance, 3);
        }
        return Math.sqrt(numerator / totalDistance);
    }
    /**
     * Calculate total distance across all spans
     * Returns total distance in meters
     */
    get totalDistance() {
        return this.spanDistances.reduce((sum, distance) => sum + distance, 0);
    }
}
exports.MeasurementState = MeasurementState;
tslib_1.__decorate([
    mobx_1.observable
], MeasurementState.prototype, "points", void 0);
tslib_1.__decorate([
    mobx_1.observable
], MeasurementState.prototype, "isActive", void 0);
tslib_1.__decorate([
    mobx_1.observable
], MeasurementState.prototype, "isPaused", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], MeasurementState.prototype, "setActive", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MeasurementState.prototype, "setPaused", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MeasurementState.prototype, "addPoint", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MeasurementState.prototype, "updatePointLocation", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MeasurementState.prototype, "removePoint", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MeasurementState.prototype, "clearPoints", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MeasurementState.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.computed
], MeasurementState.prototype, "spanDistances", null);
tslib_1.__decorate([
    mobx_1.computed
], MeasurementState.prototype, "rulingSpan", null);
tslib_1.__decorate([
    mobx_1.computed
], MeasurementState.prototype, "totalDistance", null);
//# sourceMappingURL=measurement.state.js.map